export const TRANSLATIONS_ES ={
 "header.home" : "Hogar" ,
 "header.admin.signUp": "Inscribirse",
 "footer.contactUs": "Contacta Con Nosotras",
 "page.endDate": "Fecha final",
 "page.login": "Acceso",
 "page.email": "Correo Electrónico",
 "page.company": "Compañía",
 "page.firstName": "Nombre de pila",
 "page.lastName": "Apellido",
 "page.address1": "Dirección Línea 1",
 "page.address2": "Dirección Línea 2",
 "page.city": "Ciudad",
 "page.country": "País",
 "page.state": "Estado",
 "page.zipCode": "Código postal",
 "page.zipExt": "Extensión postal",
 "page.phone": "Teléfono",
 "page.manageMFA.token":"Se requiere ficha.",
 "page.MFAModel.header":"Proporcione un token de autenticación multifactor desde la aplicación Authenticator",
 "page.MFAModel.token":"Simbólico",
 "page.MFAModel.reset":"Restablecer autenticación multifactor",
 "page.forgotPasswd.toResetPassword":"Para restablecer la contraseña",
 "page.forgotPasswd.step1":"1. Solicitud de un código de verificación que se enviará a su dirección de correo electrónico.",
 "page.forgotPasswd.step2":"2. Ingrese el código de verificación recibido junto con la nueva contraseña en los campos a continuación y envíe la solicitud.",
 "page.forgotPasswd.step1.1":"Paso 1. Proporcione la identificación de correo electrónico registrada para generar un código de verificación.",
 "page.forgotPasswd.step1.2":"Verifique su correo electrónico para obtener el código de verificación después de enviar la solicitud.",
 "page.forgotPasswd.step2.1":"Paso 2. Ingrese el código de verificación enviado por correo electrónico y la nueva contraseña en los campos a continuación y envíe la solicitud.",
 "page.forgotPasswd.verificationCode":"Código de verificación",
 "page.verification.verifyAccount":"Verifica tu cuenta",
 "page.verification.checkEmail":"Por favor revise su correo electrónico registrado para el código de verificación.",
 "page.resendCode.resend":"Vuelva a enviar el código de verificación",
 "page.login.forgotPassword":"Has olvidado tu contraseña",
 "page.submit": "Enviar",
 "page.cancel": "Cancelar",
 "page.password": "Clave",
 "header.report.suggest": "Informar un incidente",
 "page.name": "Nombre",
 "page.suggest.desc": "Descripción del incidente y fuentes",
 "info.addSuggest":"Su sugerencia de incidentes se envió con éxito.",
 "page.search": "Búsqueda",
 "page.advancedsearch": "Búsqueda Avanzada",
 "page.clear": "Claro",
 "page.page": "Página",
 "page.goToPage": "Ir a la página",
 "page.of": "de",
 "page.open": "Abierto",
 "page.close":"Cerca",
 "page.incidentSumm":"Resumen de Incidentes",
 "page.incidentType":"Tipo de Incidente",
 "page.ptIntro":"Punto de Introducción",
 "page.harmType":"Tipo de daño",
 "page.ptIntroDesc":"Descripción del punto de introducción",
 "page.harmDesc":"Descripción del daño",
 "page.harmLoc":"Daños ubicación",
 "page.numIll":"Número de enfermedades",
 "page.numDeath":"Número de muertes",
 "page.motivation":"Motivación",
 "page.motivationDesc":"Descripción de la motivación",
 "page.primMethodAdu":"Método primario de adulteración",
 "page.secMethodAdu": "Método secundario de adulteración",
 "page.numRef":"Número de referencias",
 "page.consumerBrand":"Marca de consumo",
 "page.affFoodProd":"Producto alimenticio afectado",
 "page.qtyAdulterant":"Cantidad de adulterante usado",
 "page.longTermImpact":"Impacto a largo plazo",
 "page.history":"Historia",
 "page.citation":"Citación",
 "page.authors":"Authors",
 "page.date":"Date",
 "page.title":"Title",
 "page.source":"Source",
 "page.volume":"Volume",
 "page.foodCat":"Categoría de Comida",
 "page.yearBegan":"Comenzó el año",
 "page.yearEnded":"Año finalizado",
 "page.aduFoodProd":"Productos alimenticios adulterados",
 "page.adulterant":"Adulterantes",
 "page.methodAdu":"Método de adulteración",
 "page.origLoc":"Ubicaciones originadas",
 "page.action": "Acción",
 "page.confirmationMessage": "Estas seguro?",
 
 "error.MFATokenError": "Error!! El token de autenticación multifactor proporcionado no es válido.",
 "error.getParamFailed":"Error!! no se recuperaron Los parámetros de búsqueda",
 "error.searchFailed":"Error!! La lista de eventos no fue recuperada",
 "error.minSearchParam":"Si no se proporciona texto de búsqueda o si el texto de búsqueda es inferior a 3 caracteres, entonces se debe proporcionar al menos un parámetro de búsqueda avanzado.",
 "error.changePasswordFailed":"Error!! Cambio de contraseña falló. Por favor, inténtelo de nuevo más tarde",
 "error.error":"Error!!",
 "error.userAuthFailed":"Autenticación de usuario fallida.",
 "error.emailReqd":"Correo electronico es requerido.",
 "error.invalidEmail":"Proporcione una identificación de correo electrónico válida!",
 "error.passwdReqd":"Se requiere contraseña.",
 "error.weakPassword":"Elija una contraseña segura con un mínimo de 8 caracteres, un número y un carácter especial!",
 "error.passwdMatchFailed":"Las contraseñas no coinciden!",
 "error.MFAAuthFailed": "Error!! La autenticación multifactor falló ",
 "error.MFAStateError": "Error!! Hubo un error al cambiar el estado de MFA.",
 "error.termsUpdateFailed": "Error!! Actualización de términos y condiciones fallida.",
 "error.retypePasswdReqd":"Se requiere volver a escribir la contraseña!",
 "error.sendCodeError":"Error!! Error al enviar el código de verificación para restablecer la contraseña. Por favor, inténtelo de nuevo más tarde",
 "error.codeReqd":"Se necesita un código de verificación!",
 "error.verificationFailed":"Error!! Fallo en la verificación. Por favor, inténtelo de nuevo más tarde",
 "error.resendVerificationFailed":"Error!! Error al reenviar el código de verificación. Por favor, inténtelo de nuevo más tarde",
 "error.userNameReqd":"Se requiere nombre de usuario.",
 "error.firstNameReqd":"Se requiere el primer nombre.",
 "error.lastNameReqd":"Se requiere apellido.",
 "error.compNameReqd":"Se requiere el nombre de la empresa.",
 "error.stateReqd":"Se requiere estado.",
 "error.addUserFailed":"Agregar usuario fallido.",
 "error.phoneReqd":"Se requiere teléfono.",
 "error.phoneEmailReqd":"Se requiere teléfono o correo electrónico.",
 "error.descReqd":"Se requiere una descripción.",
 "error.userEditFailed":"Error!! La información del cliente no se actualizó",
 "error.addSuggestFailed":"Hubo un problema para enviar su sugerencia de incidentes.",
 "error.unhandledException":"Tipo de acción no controlada",
 "error.getCountryFailed":"Error!! No se recuperó la lista de países",
 "error.getStateFailed":"Error!! No se recuperó la lista de estados",
 "error.sessionTimeout":"Se ha agotado el tiempo de sesión. Por favor inicie sesión nuevamente.",
 "error.logoutFailed":"Error al cerrar sesión.",
}